import { memo } from "react";
import { Avatar, Badge, Button, Card, Divider, Space, Typography } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { getInitials } from "../profile.utils";

const { Title, Text } = Typography;


function ProfileSidebarComponent({ displayName, userId, role, onSignOut }) {
  const initials = getInitials(displayName);

  return (
    <Card
      style={{ borderRadius: 16, border: "1px solid #f0f0f0", textAlign: "center" }}
      styles={{ body: { padding: "32px 24px" } }}
    >
      <div style={{ position: "relative", display: "inline-block", marginBottom: 20 }}>
        <Avatar
          size={96}
          style={{
            background: "linear-gradient(135deg, #1677ff, #0958d9)",
            fontSize: 36,
            fontWeight: 700,
            boxShadow: "0 8px 24px rgba(22,119,255,0.35)",
          }}
        >
          {initials}
        </Avatar>
        <div
          style={{
            position: "absolute",
            bottom: 2,
            right: 2,
            width: 18,
            height: 18,
            background: "#52c41a",
            borderRadius: "50%",
            border: "2px solid white",
          }}
        />
      </div>

      <Title level={4} style={{ margin: "0 0 4px" }}>
        {displayName}
      </Title>

      <Divider style={{ margin: "0 0 20px" }} />

      <Space direction="vertical" size={12} style={{ width: "100%", textAlign: "left" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Text style={{ color: "#8c8c8c", fontSize: 13 }}>UST UID</Text>
          <Text style={{ fontSize: 13, fontWeight: 600 }}>{userId || "-"}</Text>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Text style={{ color: "#8c8c8c", fontSize: 13 }}>Role</Text>
          <Text style={{ fontSize: 13, fontWeight: 600 }}>{role || "-"}</Text>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Text style={{ color: "#8c8c8c", fontSize: 13 }}>Organization</Text>
          <Text style={{ fontSize: 13, fontWeight: 600 }}>UST</Text>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Text style={{ color: "#8c8c8c", fontSize: 13 }}>Status</Text>
          <Badge
            status="success"
            text={<Text style={{ fontSize: 13, color: "#52c41a", fontWeight: 600 }}>Active</Text>}
          />
        </div>
      </Space>

      <Divider style={{ margin: "20px 0" }} />

      <Button block danger icon={<LogoutOutlined />} style={{ borderRadius: 8 }} onClick={onSignOut}>
        Sign Out
      </Button>
    </Card>
  );
}

export const ProfileSidebar = memo(ProfileSidebarComponent);
